import { BookOpenCheck, Boxes, BriefcaseBusiness, Code2, Compass, FileUser, GitBranch, HelpCircle, Laptop, Lightbulb, MessageSquareText, Presentation, Target, UsersRound } from "lucide-react";
import { InterestCategory } from "../publicLanding/InterestForm";

export const workshopNavLinks = [
    { id: "upcoming-workshops", label: "Upcoming Workshops" },
    { id: "why-workshops", label: "Why MockZo" },
    { id: "workshop-process", label: "How It Works" },
    { id: "workshop-faq", label: "FAQ" },
];

export const fallbackWorkshopCategories: InterestCategory[] = [
    { value: "web-development", label: "Web Development" },
    { value: "app-development", label: "App Development" },
    { value: "game-development", label: "Game Development" },
    { value: "interview-preparation", label: "Interview Preparation" },
    { value: "resume-linkedin", label: "Resume / LinkedIn" },
    { value: "git-collaboration", label: "Git & Collaboration" },
    { value: "other", label: "Other" },
];

export const workshopBenefits = [
    [Target, "Focused learning", "Each workshop has a clear outcome instead of trying to cover an entire subject at once."],
    [Laptop, "Hands-on practice", "Where the topic allows, students work through examples, exercises or practical activities during the session."],
    [BriefcaseBusiness, "Career context", "Concepts are connected to how they can be used in projects, internships, portfolios or interviews."],
    [HelpCircle, "Ask and understand", "Interactive sessions help students clarify doubts and understand why something works, not only what to type or memorize."],
] as const;

export const workshopOutcomes = [
    [BookOpenCheck, "Clearer Understanding", "Know the important concepts."],
    [Code2, "Practical Exposure", "See how those concepts are actually used."],
    [Boxes, "Something to Practice", "Leave with exercises, tasks or next steps where relevant."],
    [Compass, "Direction", "Understand what to learn next instead of being overwhelmed by a huge roadmap."],
    [BriefcaseBusiness, "Career Relevance", "Know where the skill fits in projects, internships and hiring."],
] as const;

export const workshopAreas = [
    [Code2, "Technical Skills", "Web development, application development, game development and other practical technical topics."],
    [GitBranch, "Development Workflows", "Git, collaboration, project structure, deployment and publishing."],
    [MessageSquareText, "Interview Preparation", "Technical interview preparation, communication and problem-solving approaches."],
    [FileUser, "Career Profile", "Resume, portfolio and LinkedIn fundamentals."],
    [Presentation, "Project Readiness", "How to move from learning concepts to building complete projects."],
] as const;

export const workshopSteps = [
    ["Understand", "Learn the key ideas without unnecessary complexity."],
    ["See it applied", "Follow practical examples and demonstrations."],
    ["Practice", "Apply the concept through guided exercises where appropriate."],
    ["Continue", "Leave knowing what to practice or build next."],
];

export const workshopAudiences = [
    [Lightbulb, "Beginners", "Who need a structured introduction to a useful topic."],
    [BookOpenCheck, "Students already learning online", "Who want interactive explanation and practical context."],
    [Laptop, "Students preparing for projects", "Who need enough understanding to start building."],
    [UsersRound, "Students preparing for placements", "Who want to strengthen technical or career fundamentals."],
] as const;

export const workshopFaqs = [
    ["Are workshops online or offline?", "Delivery mode depends on the workshop. Each workshop page clearly shows whether it is online, offline or available in both formats."],
    ["Do I need prior knowledge?", "Prerequisites depend on the workshop and are listed clearly before registration."],
    ["Will I receive workshop materials?", "Any included resources, assignments or downloads are listed on the individual workshop page."],
    ["Are workshops only for MockZo internship students?", "No. Workshops are independent MockZo programs and students can enroll directly."],
    ["Can colleges organize private workshops?", "Yes. Colleges can contact MockZo about workshops for student batches and specific career-readiness needs."],
];
